import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-dialog-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './dialog-skeleton.component.html',
  styleUrl: './dialog-skeleton.component.scss',
})
export class DialogSkeletonComponent {}
